export class ShiptoModel
{
    salesorg: string
    division: string
    distchannel: string
    cust_code: string
    code: string
    name: string
    add_1: string
    add_2: string
    add_3: string
    add_4: string
    city: string
    postcode: string
    tel_no: string
    province_code: string
    province_name: string
    cont_name: string
    selected: Boolean
    shipto_acct_grp: string
    insertion_category_id: string // CCLIORDER-1469 Adhoc Customer
}


// WEBPACK FOOTER //
// ./src/models/customer/shipto.model.ts